import { render, staticRenderFns } from "./DataPicker.vue?vue&type=template&id=5b274e7c&scoped=true"
import script from "./DataPicker.vue?vue&type=script&lang=js"
export * from "./DataPicker.vue?vue&type=script&lang=js"
import style0 from "./DataPicker.vue?vue&type=style&index=0&id=5b274e7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b274e7c",
  null
  
)

export default component.exports